import {Injectable} from '@angular/core';
import {CommonResponse} from "../response/common.response";
import {ReportefallaEntity} from "../entity/reportefalla.entity";
import {ApiReportefallaRepository} from "../../data/datasource/api/reportefalla/api.reportefalla.repository";

@Injectable({
    providedIn: 'root'
})
export class Reportefalla extends ReportefallaEntity {

    constructor(
        public apiReportefallaRepository?: ApiReportefallaRepository,
    ) {
        super();
    }

    public static build(data: {}, apiReportefallaRepository?: ApiReportefallaRepository) {
        const item = new Reportefalla();
        item.apiReportefallaRepository = apiReportefallaRepository;
        // tslint:disable-next-line:forin
        for (const propiedad in data) {
            item[propiedad] = data[propiedad];
        }
        return item;
    }

    public async registrar(objeto: any): Promise<CommonResponse> {
        return await this.apiReportefallaRepository.registrar(objeto);
    }

    public async getByTrabajadorID(trabajadorId): Promise<CommonResponse> {
        return await this.apiReportefallaRepository.getByTrabajadorID(trabajadorId);
    }

    public async obtenerListaPorPaginacion(busqueda: any, pagina: any, registros: any): Promise<CommonResponse> {
        return await this.apiReportefallaRepository.obtenerListaPorPaginacion(busqueda, pagina, registros);
    }

    public async listarPorEmpresaAnioSede(empresaId: any, anio: any, sedeId: any): Promise<CommonResponse> {
        return await this.apiReportefallaRepository.listarPorEmpresaAnioSede(empresaId, anio, sedeId);
    }

}
